// packages/react/src/components/util/RouteConstants.ts
// Route table + related types/values for the IVW-2.0 app-shell (v1 parity — mirrors
// InductVisibilityWebsite-1.0/src/components/util/RouteConstants.js).

import type { ComponentType } from 'react';
import Associate from '../associate/Associate';

/**
 * A single concrete route in the app-shell route table.
 * `exact` mirrors v1's `<Route exact .../>` usage for the packageList variants.
 */
export interface RouteConfig {
  path: string;
  component: ComponentType;
  exact?: boolean;
}

/**
 * Redirect table: request path -> canonical target path.
 * v1 populated this for /induct, /receive, /inductManagement, /inbound. In v2 it starts
 * empty (those screens are not migrated yet) but the mechanism is preserved for parity.
 */
export type DefaultRoutes = Readonly<Record<string, string>>;

// DarkMode is a leaf module (`./DarkMode`) to break a runtime circular
// dependency (ParentDataHandler -> RouteConstants -> Associate -> ParentDataHandler).
// Re-exported here for backward compatibility with existing importers.
export { DarkMode } from './DarkMode';

/**
 * Concrete route table. Only /associate is migrated today; additional 1.0 routes
 * are appended here as their screens land — this is the parity roadmap seam.
 */
export const ROUTES: readonly RouteConfig[] = [
  { path: '/associate', component: Associate },
];

/**
 * Redirect map (path -> canonical target). Empty until the parent feature areas are migrated.
 * Preserved to mirror v1 DEFAULT_ROUTES behavior.
 */
export const DEFAULT_ROUTES: DefaultRoutes = {};
